import { ArpMediaType } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useArpCollaborators } from '../hooks'
import { Card, Collaborators } from '../primitives'

export const ArpCollaboratorsCard: FC<{ media: IArpMedia }> = observer(({ media }) => {
  const { type, id, user } = media
  const { walletAddress, profilePicture, displayName } = user
  const { data, status } = useArpCollaborators(media)
  return (
    <Card.Root css={{ minHeight: '300px' }}>
      {(() => {
        if (status !== 'ready') return <Card.Loader />
        return (
          <Card.Content>
            <Card.Text title>Collaborators</Card.Text>
            <Collaborators.Root>
              <Collaborators.Header>
                <Collaborators.Link noOverflow href={`/profile/${walletAddress}`} target="_blank">
                  <Collaborators.Avatar src={profilePicture?.url} />
                  <Collaborators.Title big>{displayName}</Collaborators.Title>
                  <Collaborators.Title big success>
                    {type === ArpMediaType.SONG && 'Song creator'}
                    {type === ArpMediaType.STEM && 'Sound creator'}
                  </Collaborators.Title>
                </Collaborators.Link>
              </Collaborators.Header>
              <Collaborators.Body>
                {data.map((user) => (
                  <Collaborators.Link
                    key={user.walletAddress}
                    href={`/profile/${user.walletAddress}`}
                    target="_blank"
                  >
                    <Collaborators.Avatar src={user.profilePicture?.url} />
                    <Collaborators.Title>{user.displayName}</Collaborators.Title>
                  </Collaborators.Link>
                ))}
              </Collaborators.Body>
            </Collaborators.Root>
          </Card.Content>
        )
      })()}
    </Card.Root>
  )
})
